
import { Component, Vue } from 'vue-property-decorator'
import { PersonService } from '@/services'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const statusMap = new Map([
    [1, { zh: '审核中', en: 'Ing' }],
    [2, { zh: '审核通过', en: 'Pass' }],
    [3, { zh: '审核不通过', en: 'Fail' }]
])

@Component({
    name: 'person-auth-detail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private personId = ''
    private person: any = { 
        user: {},
        person: {},
        status: 0
    }
    private isUpdateLoading = false
    private attachFile: any[] = []

    // 匹配状态对象
    get status() {
        let statusKeyValue = {}
        const values = [...statusMap.values()]
        const keys = [...statusMap.keys()]
        values.forEach((val, index) => {
            Reflect.set(statusKeyValue, val.en, keys[index])
        })
        return statusKeyValue
    }

    // 匹配状态中文
    get matchStatusZh() {
        const status = statusMap.get(this.person.status)
        if (!status) return ''
        return status!.zh
    }

    private created() {
        this.personId = this.$route.params.id
        this.$title(`Loading | ${this.$route.meta.title} - 牛媒`)
    }

    private mounted() {
        this.getCompanyDetail()
    }

    /** 获取人物详情 */
    private async getCompanyDetail() {
        const params = {
            id: +this.personId
        }
        const result = await PersonService.getPersonAuthDetail(params)
        if (result.status === 200) {
            const { image1, image2 } = result.data
            this.person = result.data
            this.attachFile = [image1, image2]
            this.$title(`${result.data.person.name} | ${this.$route.meta.title} - 牛媒`)
        }
    }

    /** 修改人物状态 */
    private async changeStatus(status: number) {
        const params = {
            id: +this.personId,
            status
        }
        const result = await PersonService.updatePersonAuthStatus(params)
        if (result.status === 200) {
            this.person.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

    private matchButtonType(status: number) {
        return this.person.status === status ? 'primary' : 'default'
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }

}
